import Vue from 'vue'
import Vuex from 'vuex'

import medals from './medals'
import recipients from './recipients'
import themes from './themes'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        medals,
        recipients,
        themes
    },
    strict: debug
})
